import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../../styles";
import RoadmapCards from "./RoadmapCards";

const index = () => {
  return (
    <div style={{ backgroundColor: "#336799" }}>
      <SectionWrapper
        bgColor="#FF0029"
        id="roadmap"
        // data-aos="fade-zoom-in"
        // data-aos-easing="ease-in"
        // data-aos-delay="500"
        // data-aos-offset="0"
      >
        <Container maxWidth="xl">
          <Grid container justifyContent="flex-start">
            <Grid xs={12}>
              <SectionHeading m="60px" mb="0px" fs="190px">
                Roadmap
              </SectionHeading>
              <P mt="10px" mb="10px">
                Below is a brief representation of some of the up-and-coming
                announcements:
              </P>
            </Grid>
            <Grid xs={12} style={{ padding: "0px 0" }} />
            <RoadmapCards
              bg="#ffffff"
              cardNumber="phase 01"
              cardDiscription1="Dollar Inu launch on Ethereum"
              cardDiscription2="RRC testnet"
              cardDiscription3="Twitter and Telegram community"
              cardDiscription4="Reaching out to impactful investors"
            />
            <RoadmapCards
              cardNumber="phase 02"
              cardDiscription1="RRC mainnet"
              cardDiscription2="RRT announcement"
              cardDiscription3="Strengthening the Telegram community"
              cardDiscription4="Diversifying Twitter’s reach"
            />
            <RoadmapCards
              cardNumber="phase 03"
              cardDiscription1="RRT launch"
              cardDiscription2="Bridge"
              cardDiscription3="Marketing campaign"
              cardDiscription4="Launching more meme tokens"
            />
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
